import React from 'react';
import { usePopoverContext } from '../Popover/PopoverLogic';
import VoxelMenuItem, { VoxelMenuItemProps } from './VoxelMenuItem';

export interface VoxelPopoverMenuItemProps extends VoxelMenuItemProps {
  closePopoverOnClick?: boolean;
}

export const VoxelPopoverMenuItem: React.FC<VoxelPopoverMenuItemProps> = ({
  onClick,
  closePopoverOnClick = true,
  ...props
}) => {
  const popoverContext = usePopoverContext();

  return (
    <VoxelMenuItem
      onClick={(e) => {
        onClick && onClick(e);
        closePopoverOnClick && popoverContext?.setOpen(false);
      }}
      {...props}
    />
  );
};

export default VoxelPopoverMenuItem;
